export default __webpack_public_path__ + "assets/Asteroid_mining.938d1918.png";